import React from 'react';

// Inject the shimmer keyframes once, globally — mirrors the admin Spinner's
// same self-registering pattern (admin/src/components/Spinner.tsx).
if (typeof document !== 'undefined' && !document.getElementById('skeleton-shimmer-keyframes')) {
  const style = document.createElement('style');
  style.id = 'skeleton-shimmer-keyframes';
  style.textContent = '@keyframes skeleton-shimmer { 0% { background-position: -150% 0; } 100% { background-position: 150% 0; } }';
  document.head.appendChild(style);
}

export function Skeleton({ style }: { style?: React.CSSProperties }) {
  return (
    <div
      style={{
        width: '100%', height: '100%', borderRadius: 4,
        background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 37%, #f1f5f9 63%)',
        backgroundSize: '400% 100%',
        animation: 'skeleton-shimmer 1.4s ease infinite',
        ...style,
      }}
    />
  );
}
